import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TbLogin2 } from "react-icons/tb";
import { FaSignOutAlt } from 'react-icons/fa';
const SignOut = ({ onSignOut }) => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    console.log('SignOut button clicked'); // Log to check if the button click is being captured

    const token = localStorage.getItem('google_token');
     
    if (token) {
      console.log('Token found:', token); // Log the token to ensure it's retrieved

      try {
        const response = await fetch(`${process.env.REACT_APP_LOGOUT_URL}`, {
          method: 'POST',
          headers: {
            'Accept': '*/*',
            'X-Authorization': `Bearer ${token}`,
          },
        });

        if (response.ok) {
          console.log('Logout request successful:', response); // Log the successful response

          // Clear the token from localStorage
          localStorage.removeItem('google_token');

          // Call the parent component's callback to update state
          onSignOut(); 

          // Redirect to Hero page (landing page)
          navigate('/explore'); 
          
          // Reload the page to ensure all session data is cleared
          window.location.reload(); // Force a page reload
        } else {
          console.error('Sign-out failed with status:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error during sign-out:', error); // Log any fetch errors
      }
    } else {
      console.log('No token found in localStorage'); // Log if no token is found

      // Even if no token is found, perform a sign-out operation
      onSignOut(); 

      // Navigate to Hero page
      navigate('/explore');
      
      // Reload the page to ensure state is refreshed
      window.location.reload();
    }
  };

  return (
    <button
              onClick={handleSignOut}  // Sign Out Functionality
              className="w-full text-left text-red-500 py-2 px-4 flex items-center hover:bg-red-50 rounded-md transition-colors duration-200"
            >
              <FaSignOutAlt className="mr-2" />
              Sign Out
            </button>
  );
};

export default SignOut;
